import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
} from "antd";
import axios from "axios";
import { UploadOutlined } from "@ant-design/icons";
import { IPLogsTable } from "./IPLogsTable";
import "./IPLogs.css";
import { LanguageContext } from "../../context/LanguageContext";

const { Option } = Select;
const FormItem = Form.Item;
let columns = [];
let data = [];
const baseUrl = `${process.env.REACT_APP_URL}/api`;
//const baseUrl = 'http://localhost:8080/api';
class IPLogs extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
  }
  state = {
    isCreateUserDrawerVisible: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    progress: 0,
    fileList: [],
    uploadedFileName: "",
  };
  userForm = React.createRef();

  componentDidMount() {
    const { user } = this.props;
    this.props.dispatch(userActions.getIPLogs(user.id));
    if (user && user.cityId && user && user.role === "4") {
      this.props.dispatch(professionalAction.getAllNews(4));
    } else if (user && user.role === "8") {
      this.props.dispatch(professionalAction.getAllNews(4));
    }
  }

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { language, t } = this.context;
    const requiredKeys = [];
    if (
      users.ip_logs &&
      users.ip_logs.iplogs &&
      users.ip_logs.iplogs.length > 0
    ) {
      let columns1 =
        users.ip_logs.iplogs &&
        users.ip_logs.iplogs.length &&
        users.ip_logs.iplogs.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
            [t("sr.no")]: index + 1,
          };
        });

      let tablelabes = columns1 && Object.keys(columns1[0]);

      let tableColumns = [];
      tableColumns && tableColumns.unshift(t("sr.no"));
      tablelabes.forEach((item) => {
        if (
          _.filter(requiredKeys, function (o) {
            return o === item;
          }).length
        ) {
          tableColumns.push(item);
        }
      });

      let columnList = tableColumns.map((item) => {
        return {
          title: item,
          dataIndex: item,
          key: item,
        };
      });
      // columns1.reverse();
      data = columns1;
      columns = columnList;
    } else {
      data = [];
    }
    const roleFour = user && user.role === "4" ? "घटक" : "जिल्हा";
    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            title={user && user.userid}
            subTitle={
              user && user.role === "4"
                ? `(${t("admin")})`
                : `(${t("super_admin")})`
            }
            extra={[]}
          >
            <Descriptions size="small" column={3}>
              <Descriptions.Item label="Last Login Details"></Descriptions.Item>
            </Descriptions>
          </PageHeader>
        </div>

        <Divider />
        <IPLogsTable
          data={data}
          columns={columns}
          userRole={user}
        ></IPLogsTable>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
  };
}

const connectedIPLogs = connect(mapStateToProps)(IPLogs);
export { connectedIPLogs as IPLogs };
